import { afterEvent, cardRef, defineGameCard } from '../authoring/index.js';
import { addGrowth, hasTrait, isLiveOnBoard, THORNS_GROWTH_REWARDS_KEY, THORNS_VALUE_KEY, } from './plant-helpers.js';
/**
 * Колючки N — публичный persistent-эффект пустой вражеской ячейки. Следующая
 * карта противника владельца, раскрытая в этой ячейке, получает суммарный N
 * урон, после чего весь эффект полностью снимается. Повторные Колючки
 * складываются. Токены и собственные карты владельца Колючки
 * не запускают; скрытые планы эффект не читает — он реагирует только на
 * публичный UnitEnteredPlay в свою ячейку.
 */
export const PlantThornsCard = defineGameCard({
    id: 'plant_thorns',
    gameplay: { type: 'EFFECT', cost: 0 },
    presentation: {
        name: 'Колючки',
        description: 'Следующая карта противника, раскрытая в этой ячейке, получает урон, равный сумме Колючек, затем все Колючки снимаются.',
        glyph: {
            colors: ['#6B4A2E', '#B08968', '#E8D0B0'],
            rows: [
                '.........',
                '.........',
                '.........',
                '..2...2..',
                '.121.121.',
                '..1...1..',
                '2.1.2.1.2',
                '12121212.',
                '.1111111.',
            ],
        },
    },
    role: 'auxiliary',
    dependencies: [cardRef('plant_growth')],
    abilities: [
        afterEvent({
            event: 'UnitEnteredPlay',
            run(ctx, event) {
                const effect = ctx.effect;
                if (effect === undefined || effect.scope.kind !== 'cell' || effect.scope.cellId !== event.cellId)
                    return;
                const unit = ctx.q.instance(event.instanceId);
                if (unit === null || unit.zone !== 'board' || unit.cellId !== event.cellId)
                    return;
                if (unit.isToken || unit.controllerId === effect.vars.ownerId)
                    return;
                const raw = effect.vars[THORNS_VALUE_KEY];
                const value = typeof raw === 'number' && Number.isSafeInteger(raw) && raw > 0 ? raw : 0;
                const rawRewards = effect.vars[THORNS_GROWTH_REWARDS_KEY];
                const growthRewards = typeof rawRewards === 'number'
                    && Number.isSafeInteger(rawRewards)
                    && rawRewards > 0
                    ? rawRewards
                    : 0;
                ctx.ops.removeEffect(effect.id);
                if (value > 0) {
                    ctx.ops.dealDamage({ kind: 'unit', instanceId: unit.id }, value);
                }
                if (growthRewards > 0) {
                    const opposite = ctx.q.opposingCell(effect.scope.cellId);
                    const plant = opposite?.occupantId === null || opposite?.occupantId === undefined
                        ? null
                        : ctx.q.instance(opposite.occupantId);
                    if (isLiveOnBoard(plant)
                        && plant.controllerId === effect.vars.ownerId
                        && hasTrait(ctx, plant.id, 'PLANT')) {
                        addGrowth(ctx, plant.id, growthRewards, 'thorn_seeds');
                    }
                }
            },
        }),
    ],
    ui: {
        mechanics: ['thorns'],
        publicVars: { value: { key: THORNS_VALUE_KEY, kind: 'number' } },
        locationEffect: {
            symbol: '🌵',
            label: 'Колючки',
            description: 'Следующая карта противника, раскрытая в этой ячейке, получит {value} урона.',
            counterFact: 'value',
            showCellBadge: true,
        },
        effectStatusProviders: [(_context, effects) => {
                const value = effects.reduce((total, effect) => {
                    const current = effect.facts.value;
                    return total + (typeof current === 'number' ? current : 0);
                }, 0);
                return value > 0
                    ? [{
                            id: 'plant-thorns',
                            symbol: `🌵${value}`,
                            label: `Колючки ${value}`,
                            description: `Следующая карта противника, раскрытая в этой ячейке, получит ${value} урона, затем Колючки снимутся.`,
                            tone: 'warning',
                            compact: true,
                        }]
                    : [];
            }],
    },
});
//# sourceMappingURL=plant_thorns.js.map